import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'

import appReducer from './app/slice'
import cartReducer from './cart/slice'
import { rootPersistConfig } from './persistorConfig'

const rootReducer = combineReducers({
  cart: cartReducer,
  app: appReducer,
})

const persistedRootReducer = persistReducer(rootPersistConfig, rootReducer)

export default persistedRootReducer
